import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, formatDate } from "@/lib/api";
import { StatusPill, PublishControls } from "@/components/admin/shared";

const OK_CONSENT = ["approved", "not_required"];

export const PublishPanel = ({ data, reload }) => {
  const [settings, setSettings] = useState(null);
  useEffect(() => { http.get("/admin/settings").then((r) => setSettings(r.data)); }, [data]);

  const groups = [
    ["categories", "Layanan", data.categories, (x) => x.name],
    ["treatments", "Harga", data.treatments, (x) => x.name],
    ["packages", "Paket & Promo", data.packages, (x) => x.name],
    ["photos", "Dokumentasi", data.photos, (x) => x.caption || "Foto tanpa caption"],
    ["testimonials", "Testimoni", data.testimonials, (x) => x.name || x.text.slice(0, 40)],
    ["faqs", "FAQ", data.faqs || [], (x) => x.question],
  ];
  const pending = groups.flatMap(([coll, label, list, title]) =>
    list.filter((x) => x.status !== "published" || x.has_changes).map((x) => ({ coll, label, item: x, title: title(x) })));

  const publishSettings = async () => {
    try {
      const r = await http.post("/admin/settings/publish");
      setSettings(r.data);
      toast.success("Konten website diterbitkan");
    } catch (e) { toast.error(errMsg(e)); }
  };

  const blocked = ({ coll, item }) =>
    (coll === "photos" && !OK_CONSENT.includes(item.consent)) || (coll === "testimonials" && !item.consent_confirmed);

  return (
    <div data-testid="publish-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <p className="text-sm text-nanina-muted">Draft dan perubahan di bawah belum terlihat oleh pengunjung sampai diterbitkan.</p>
        <Link to="/admin/preview" target="_blank" className="inline-flex items-center gap-1.5 rounded-full border border-nanina-green text-nanina-green text-sm font-semibold px-4 py-2" data-testid="publish-preview-link"><Eye className="h-4 w-4" /> Pratinjau website</Link>
      </div>
      <ul className="space-y-2">
        {settings?.has_changes && (
          <li className="flex flex-wrap items-center gap-3 rounded-2xl bg-white border border-nanina-butter p-3" data-testid="publish-settings-row">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-nanina-green">Konten website & jam operasional</p>
              <p className="text-[11px] text-nanina-muted">Terakhir terbit {formatDate(settings.published_at) || "-"}</p>
            </div>
            <button onClick={publishSettings} className="rounded-full bg-nanina-green text-white text-[11px] font-semibold px-3 py-1.5" data-testid="publish-settings-button">Terbitkan</button>
          </li>
        )}
        {pending.map((p) => (
          <li key={`${p.coll}-${p.item.id}`} className="flex flex-wrap items-center gap-3 rounded-2xl bg-white border border-nanina-line p-3" data-testid={`pending-${p.coll}-${p.item.id}`}>
            <span className="text-[10px] rounded-full bg-nanina-skysoft text-nanina-green px-2 py-0.5 font-semibold">{p.label}</span>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-nanina-green truncate">{p.title}</p>
              <StatusPill item={p.item} />
            </div>
            {blocked(p) ? <span className="text-[11px] text-[#8A6D3B]">Konfirmasi izin dulu</span> : <PublishControls item={p.item} coll={p.coll} reload={reload} testId={`pending-${p.item.id}`} />}
          </li>
        ))}
      </ul>
      {!pending.length && !settings?.has_changes && <p className="rounded-2xl border border-dashed border-nanina-line p-6 text-center text-sm text-nanina-muted" data-testid="publish-all-clear">Semua konten sudah terbit.</p>}
    </div>
  );
};
